<template>
    <b-container fluid>
        <b-row v-if="showButtonBar">
            <b-col>
                <b-button-toolbar
                    key-nav
                    aria-label="Toolbar with button groups"
                    class="float-right"
                >
                    <b-button-group v-if="copy">
                        <b-button @click="setToClipBoard(copyValue)">
                            copy
                        </b-button>
                    </b-button-group>
                    <b-button-group v-if="showExtraData">
                        <b-button
                            @click="extraExpanded = !extraExpanded"
                            :active="extraExpanded"
                        >
                            data sheet
                        </b-button>
                    </b-button-group>
                </b-button-toolbar>
            </b-col>
        </b-row>
        <b-row>
            <b-col
                v-for="(col, colIndex) in tableFields"
                :key="`col_${colIndex}`"
            >
                <dl>
                    <data-display-field
                        v-for="(field, index) in col"
                        :key="`list_${field.name}_${index}`"
                        :displayDataField="field"
                        :noLabels="noLabels"
                        :i8nPrefix="i8nPrefix"
                    />
                </dl>
            </b-col>
        </b-row>
        <b-row v-if="showExtraData">
            <b-col>
                <b-collapse v-model="extraExpanded">
                    <data-display-object
                        :displayDataObject="extraFields"
                        :i8nPrefix="i8nPrefix"
                    />
                </b-collapse>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
    import DataDisplayField from './DataDisplayField.vue';
    import DataDisplayObject from './DataDisplayObject.vue';

    export default {
        components: {
            'data-display-field': DataDisplayField,
            'data-display-object': DataDisplayObject
        },
        props: {
            displayData: { type: [Object, Array], required: true },
            fields: { type: Array, default: () => [] },
            extra: { type: Boolean },
            copy: { type: Boolean },
            noLabels: { type: Boolean },
            i8nPrefix: { type: String, default: '' }
        },
        data() {
            return { extraExpanded: false };
        },
        computed: {
            dataArray() {
                return this.extractItems(this.displayData);
            },
            tableFields() {
                return this.requiredTableFields;
            },
            optionalFields() {
                return [];
            },
            requiredTableFields() {
                if (this.hasRequiredFields) {
                    if (Array.isArray(this.fields[0])) {
                        return this.fields.map((item) => {
                            return item.map((subItem) => this.getField(subItem));
                        });
                    }
                    return [
                        this.fields.map((item) => {
                            return this.getField(item);
                        })
                    ];
                }
                return [this.dataArray.filter((item) => item.display)];
            },
            copyValue() {
                return this.tableFields.map(({ value }) => value).join(' ');
            },
            extraFields() {
                return this.dataArray;
            },
            hasRequiredFields() {
                return this.fields.length > 0;
            },
            showExtraData() {
                return this.extra && this.extraFields.length > 0;
            },
            showButtonBar() {
                return this.showExtraData || this.copy;
            }
        },
        methods: {
            getField(name) {
                return {
                    name,
                    value:
                        this.dataArray.find((field) => field.name === name)
                            ?.value || '-'
                };
            },
            setToClipBoard(value) {
                navigator.clipboard.writeText(value);
            },
            extractItems(data) {
                if (Array.isArray(data)) {
                    return data.map((item) => this.extractItems(item));
                }
                if (typeof data === 'object') {
                    const entries = Object.entries(data);
                    return entries.map((item) => {
                        const val = item[1];
                        const valType = typeof val;
                        if (
                            valType === 'string' ||
                            valType === 'number' ||
                            val === null
                        ) {
                            const required = this.fields.includes(item[0]) || null;
                            const optional =
                                this.optionalFields.includes(item[0]) || null;
                            const value =
                                (required && (item[1] ? item[1] : '-')) || item[1];
                            return {
                                name: item[0],
                                value,
                                required,
                                optional,
                                display:
                                    required || optional || !this.hasRequiredFields
                            };
                        }
                        return {
                            name: item[0],
                            items: this.extractItems(item[1])
                        };
                    });
                }
                return data;
            }
        }
    };
</script>
